export const environment = {
  appName: 'EZYEST',
  production: false,
  crossDomainURL: 'https://reraconnectdev.arcise.in/',
  crossDomainAPI: 'https://reraconnectdev.arcise.in/api',
  isReleaseMode: false,
  cryptoAesKey: '0B87pklDRdM1U5kYyduMAkrkiRsBx0YdbRR/SIADhIk=',
  cryptoAesIV: 'DiP87QAc/U2fa/KHlvtTRA==',
  imageUploadFileType: '.jpg, .png, .jpeg',
  videosUploadFileType: 'mp4, .mov, .avi, .gif, .gifv, .3gp',
  dateFormat: 'DD-MM-YYYY',
  dateFormatList: 'dd-MM-yyyy',
  dateFormatCaps: 'dd-MM-YYYY',
  listingDateTimeFormat: 'dd-MM-yyyy, h:mm:ss a',
  googleApiKey: 'AIzaSyAVmoHYRvDYb3AV248V6ElJYBu8i2DS3Aw',
};
